import React from 'react';
import WorkflowUserName from 'components/WorkflowUserName/WorkflowUserName';
import useWorkflowUser from 'store/useWorkflowUser';

function UserFullName(props: { id: string }) {
  const { name, isAccountWorker } = useWorkflowUser(props.id);
  return <WorkflowUserName name={name} isAccountWorker={isAccountWorker} />;
}

export default React.memo(UserFullName);
